import barba from '@barba/core';
import gsap from 'gsap';

barba.init({
	transitions: [{
		name: 'opacity-transition',
		leave(data) {
			return gsap.to(data.current.container, {
				opacity: 0,
			}).then(() => {
				data.current.container.style.display = 'none';
			});
		},
		beforeEnter() {
			const $sprigComponents = document.querySelectorAll('.sprig-component');
			if ($sprigComponents) {
				$sprigComponents.forEach(($sprigComponent) => {
					htmx.process($sprigComponent);
				});
			}
		},
		enter(data) {
			const parser = new DOMParser();
			const next = parser.parseFromString(data.next.html, 'text/html');
			const selectors = ['footer#footer', 'body', '.header__button'];
			selectors.forEach((selector) => {
				const nextElement = next.querySelector(selector);
				const currentElement = document.querySelector(selector);
				if (nextElement && currentElement) {
					currentElement.classList.remove(...currentElement.classList);
					currentElement.classList.add(...nextElement.classList);
				}
			});
			window.scrollTo(0, 0);
			return gsap.from(data.next.container, {
				opacity: 0,
			});
		},
	}],
});
